import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes,
  Route } from 'react-router-dom';

import App from './App';
import './index.css';
import PrivacyPolicies from './routes/privacy_policies.js';
import TermsOfServices from './routes/terms_of_service.js';

ReactDOM.render(
  <BrowserRouter>
  <Routes>
      <Route path="/" element={<App />} />
      <Route path="privacy-policies" element={<PrivacyPolicies/>} />
      <Route path="terms-of-service" element={<TermsOfServices/>} />
    </Routes>
    </BrowserRouter>
,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js